import React, { ReactNode } from 'react';

export const replaceDynamicVariable = (
  node: ReactNode,
  variable: string,
  value: string
) => {
  if (typeof node === 'string') {
    return node.replace(new RegExp(`\\${variable}`, 'g'), value);
  }

  if (React.isValidElement(node)) {
    return React.cloneElement(node, {
      ...node.props,
      children: React.Children.map(node.props.children, child =>
        replaceDynamicVariable(child, variable, value)
      ),
    });
  }

  if (Array.isArray(node)) {
    return node.map(child =>
      React.cloneElement(child, {
        ...child.props,
        children: React.Children.map(child.props.children, child2 =>
          replaceDynamicVariable(child2, variable, value)
        ),
      })
    );
  }

  return node;
};
